import { FallbackProps } from "react-error-boundary";
import { baseRouterPath } from "../../utils/constants";
import { IoReload } from "react-icons/io5";
import { MdErrorOutline } from "react-icons/md";
import { useAppSelector } from "../../hooks";
import { selectStoreConfigSelector } from "../../store/storeConfig/selector";
import logoLn from "../../assets/images/logo-ln.svg";
import relxLogo from "../../assets/images/relx-logo.png";
import { selectFooterSelector } from "../../store/cmsBlock/selector";
import Header from "../layout/header";
import Footer from "../layout/footer";

const ErrorBoundaryFallback = (props: FallbackProps) => {
  const { error, resetErrorBoundary } = props;
  const storeData = useAppSelector(selectStoreConfigSelector);
  const cmsBlock = useAppSelector(selectFooterSelector);

  const logoSrc = storeData?.header_logo_src ?? logoLn;

  return (
    <>
      <Header logo={logoSrc} logoAlt="Lexis Nexis Logo" />
      <div className="error-page min-h-[86vh] flex items-center justify-center">
        <div className="flex flex-col items-center justify-center">
          <MdErrorOutline className="h-[56px] w-[56px] text-grey-scale-slate" />
          <h1 className="text-xl font-semibold text-red-600 mb-4">
            An error has occurred
          </h1>
          <p className="text-base text-grey-scale-slate font-normal w-3/5 text-center">
            {" "}
            Something went wrong . Please try refreshing the page or check back
            later. If the issue persists, contact support for assistance.
          </p>
          <button
            data-track="reload-page"
            aria-label="Reload Page"
            className="submit-btn flex justify-center items-center mt-4"
            onClick={resetErrorBoundary}
          >
            Reload Page <IoReload className="ml-2" />
          </button>
          {/* <a href="#" className="text-blues-denim mt-2">Contact Support</a>  // Need to add link for contact Support */}
        </div>
      </div>

      {cmsBlock?.items == null && (
        <Footer logo={logoLn} logoAlt="Lexis Nexis Logo" />
      )}
    </>
  );
};

export default ErrorBoundaryFallback;
